var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "hb-section",
    {
      attrs: { title: _vm.$t("influencer_panel.tab_statement") },
      scopedSlots: _vm._u([
        {
          key: "subtitle",
          fn: function () {
            return [
              _c(
                "span",
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("influencer_panel.inflows")) + " "
                  ),
                  _c("hb-money", {
                    attrs: {
                      cents: _vm.totals.inflow_cents,
                      size: "sm",
                      tone: "positive",
                    },
                  }),
                  _vm._v(
                    " · " + _vm._s(_vm.$t("influencer_panel.outflows")) + " "
                  ),
                  _c("hb-money", {
                    attrs: { cents: _vm.totals.outflow_cents, size: "sm" },
                  }),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "actions",
          fn: function () {
            return [
              _c("b-form-select", {
                staticClass: "statement__filter",
                attrs: {
                  value: _vm.type,
                  options: _vm.typeOptions,
                  size: "sm",
                  "aria-label": _vm.$t("influencer_panel.entry_type"),
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("update:type", $event)
                  },
                },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      !_vm.entries.length
        ? _c("hb-empty-state", {
            attrs: {
              title: _vm.$t("influencer_panel.no_entries"),
              icon: "FileTextIcon",
            },
          })
        : _c(
            "div",
            [
              _vm._l(_vm.entries, function (entry) {
                return _c(
                  "div",
                  { key: entry.id, staticClass: "statement__row" },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "statement__icon",
                        class:
                          "statement__icon--" +
                          (entry.direction === "CR" ? "in" : "out"),
                      },
                      [
                        _c("feather-icon", {
                          attrs: {
                            icon:
                              entry.direction === "CR"
                                ? "ArrowDownLeftIcon"
                                : "ArrowUpRightIcon",
                            size: "15",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "statement__identity" }, [
                      _c("div", { staticClass: "statement__title" }, [
                        _vm._v(_vm._s(entry.type_label)),
                      ]),
                      _c("div", { staticClass: "statement__subtitle" }, [
                        entry.description
                          ? _c("span", [
                              _vm._v(_vm._s(entry.description) + " · "),
                            ])
                          : _vm._e(),
                        _vm._v(_vm._s(_vm.shortDate(entry.created_at)) + " "),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "statement__badge" },
                      [
                        _vm.isPending(entry)
                          ? _c(
                              "b-badge",
                              { attrs: { variant: "light-warning" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "influencer_panel.entry_status_pending"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : entry.direction === "CR"
                          ? _c(
                              "b-badge",
                              { attrs: { variant: "light-success" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "influencer_panel.entry_status_available"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "statement__amount" },
                      [
                        _c("hb-money", {
                          attrs: {
                            cents: entry.signed_amount_cents,
                            signed: "",
                            tone: "auto",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                )
              }),
              _vm.lastPage > 1
                ? _c("b-pagination", {
                    staticClass: "mt-2 mb-0",
                    attrs: {
                      value: _vm.currentPage,
                      "total-rows": _vm.total,
                      "per-page": _vm.perPage,
                      align: "center",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("update:page", $event)
                      },
                    },
                  })
                : _vm._e(),
            ],
            2
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }